export default __webpack_public_path__ + "static/media/dataBricksPic.f91044d7.png";